import React,{ useEffect, useContext, useState, useRef } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { Footer } from "../../../components/Landing/Footer";
import { Banner } from "../components/Banner/Banner";
import { useNavigate } from "react-router-dom";
import getStorageUser from "../../../middlewares/GetStorageUser"
import { Form, Select, Input, Button, Collapse, Table, Empty, Row, Col, Popover, Space, Carousel } from "antd";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { QuienParticipaOptions, tipoConvocatoria } from "../../../utils/dataSelectOptions";
import { TemplateContext } from "../../../utils/template_context";
import apiMaestras from "../../../api/Maestras/api-maestras";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "antd/dist/antd.css"


import '../PeopleList.scss';

import headerPP from "../../../assets/pp/Header-PP.jpg"
import banner from "../../../assets/pp/Banner-principal.jpg"
import banner2 from "../../../assets/pp/Banner-Resenas-1.jpg"
import banner3 from "../../../assets/pp/Banner-Resenas-2.jpg"
import fomento from "../../../assets/pp/fomentoEstimulos.png"
import formacion from "../../../assets/pp/formacion.png"
import fortalecimiento from "../../../assets/pp/fortalecimiento.png"
import agenda from "../../../assets/pp/agendaCultural.png"
import cic from "../../../assets/pp/cic.png"


// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";
import { color } from "html2canvas/dist/types/css/types/color";
import { borderBottomStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";

const routes = [
  { icon: <></>, nombre: "Alcaldía de Medellín" },
  { icon: <></>, nombre: "Secretaría Cultura Ciudadana" },
  { icon: <></>, nombre: "Convocatorias de Presupuesto Participativo" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En espera": "#EFC236",
  Cerrada: "#9F0505",
};
const { Panel } = Collapse;

const blockquoteStyle = {
  background: '#FFF',
  border: 0,
  margin: '1px',
  padding: 0,
  boxShadow: 'none',
  display: 'block'
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: '#efefef',
  padding: '20px',
  borderRadius: '10px'
}

export const Pp = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    visibleButton,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  const navigate = useNavigate();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const context = useContext(TemplateContext);
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const toggleVista = () => {
    setMostrarTabla(!mostrarTabla);
  };

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };

  const fields = [
    { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
    { name: "area", value: principalState.buscarconvocatorias.area },
    { name: "entidad", value: principalState.buscarconvocatorias.entidad },
    { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
    { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
    { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
    { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
    { name: "anio", value: principalState.buscarconvocatorias.anio },
 ];

  const datosTabla = principalState.convocatoriasslice
  .filter((data: any) => data.entidad == "PP")
  .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
  .map((data: any) => ({
    // Mapear aquí los datos que quieres mostrar en la tabla
    idconvocatorias: data.idconvocatorias,
    nombre_convocatoria: data.nombre_convocatoria,
    fechas: data.fechas,
    estado: data.estado,
    entidad: data.entidad,
    linea_convocatoria: data.linea_convocatoria,
    tipo_participante: data.tipo_participante,
    area: data.area
  }));

  const columns = [
    {
      title: "Nombre convocatoria",
      width: 300,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{whiteSpace: "pre-line"}}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: 450,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: 120,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: 100,
      render: (datos) => {
        if (Array.isArray(datos.tipo_participante)) {
          var tipo_participante = ""
          datos.tipo_participante.forEach((tipo) => {
            tipo_participante += tipo.text + " - ";
          });
        }
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = new Date(fecha);
            cierreAct.setHours(cierreAct.getHours() - 1);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              var estadoAct = 'Cerrada'
            } else {
              estadoAct = datos.estado
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Áreas",
      width: 200,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [visualizarCronograma, setVisualizarCronograma] = useState<boolean>(false);
  const [visualizarPortafolio, setVisualizarPortafolio] = useState<boolean>(false);

  const mostrarModalCronograma = () => {
    setVisualizarCronograma(true);
  }

  const mostrarModalPortafolio = () => {
    setVisualizarPortafolio(true);
  }

  const contentStyle: React.CSSProperties = {
    width: '100%',
    objectFit: 'cover'
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const contentStyleC: React.CSSProperties = {
    width: "100%",
    height: "auto",
    objectFit: "cover"
  };

  const carouselRef = useRef<any>(null);
  const goToPrev = () => carouselRef.current?.prev();
  const goToNext = () => carouselRef.current?.next();

  const imageUrls = [
  'https://drive.google.com/file/d/1BX-2-8mPpHpQ8DWe70-SjKatCyPZwSf1/preview',
  'https://drive.google.com/file/d/15vAk2Rf81UpQaRaoCSOV86q1ZnI_3xhu/preview',
  'https://drive.google.com/file/d/1jDAsCWbNMfiC5rQKysl2933YS-A6ivbK/preview',
  'https://drive.google.com/file/d/1o66bW9DrUnwZf9jwmW3n3FrKkHaci-Mw/preview',
  'https://drive.google.com/file/d/1juQiTqolSKcCoG8CU75dsAhPdcjtGIdr/preview',
  'https://drive.google.com/file/d/1pUxhyvsBu3lfePeKkMe32sJFsZHJTqf4/preview',
  'https://drive.google.com/file/d/1nRCrRBgmuLkTVRLzIOz4PfiMDz70jo5E/preview',
  'https://drive.google.com/file/d/1jIiHZfgT6WyXoAFAVP-t94q4nxJAK1Mc/preview',
  'https://drive.google.com/file/d/1m4bNyo6tx27Qst5R10wQ36Ab_6wgO5j5/preview',
  'https://drive.google.com/file/d/1z4Iu0JKGkIW0j5kNEgZ3mewo135-888H/preview',
  'https://drive.google.com/file/d/1aUdHVtsEx7cJREUhC_pDoWZZ0zEvBvAh/preview',
  'https://drive.google.com/file/d/13gMx4VeQb18BukxeDkjOjnh646BFE7DW/preview',
  'https://drive.google.com/file/d/1BpAew6QsVBjTRHqD5gRnoJ9VvOf1Gxea/preview',
  'https://drive.google.com/file/d/1F6ydsuMqzTcFh1HV_dktxpAdyqpOHipv/preview',
  'https://drive.google.com/file/d/1ULflyFQUGKXZ6dzmJVd0RPT2PS1XGJ3e/preview',
  'https://drive.google.com/file/d/1WEuww0-k2vOvtnaYfmJpzyAge72ZxfOl/preview',
  'https://drive.google.com/file/d/17gJMo6okofMf0AyyW_IqY38hkjpTtisr/preview',
  'https://drive.google.com/file/d/11Jjyk0HiTdtRMwnN-MycMvpi0iLp2H0E/preview',
  'https://drive.google.com/file/d/1NteODSTHXa47_nR0vvQ-ABmT9P3PWQG8/preview',
  'https://drive.google.com/file/d/1cf4Rt746sk77H05vT-limKysnKfVSj22/preview',
  'https://drive.google.com/file/d/1VidCKfav0dTulV3KW7-0ZAz1a86jiIup/preview',
  'https://drive.google.com/file/d/1igRJVS_z5YWNBVl7_Tx1lFCs1CMe1x83/preview',
  'https://drive.google.com/file/d/1F1tpzRVICY9fbBwQalt-pfL-Ek5FGFgX/preview'
  ];

  const [failedImages, setFailedImages] = useState<Set<number>>(new Set());
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const handleImageError = (index: number) => {
    setFailedImages((prev) => new Set(prev).add(index));
  };

  const openModal = (index: number) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const next = () => {
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex + 1) % imageUrls.length);
    }
  };

  const prev = () => {
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex - 1 + imageUrls.length) % imageUrls.length);
    }
  };

  return (
    <div>
      <Header />
      <HeaderPp />
      <img src={headerPP} alt="Convocatorias arte y cultura PP" style={contentStyle} />
      <div style={{ position: "relative", margin: "0 auto" }}>
        <Carousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={3000}
          dots
          infinite
        >
          <div>
            <img src={banner} alt="Banner 1" style={contentStyleC} />
          </div>
          <div>
            <img src={banner2} alt="Banner 2" style={contentStyleC} />
          </div>
          <div>
            <img src={banner3} alt="Banner 3" style={contentStyleC} />
          </div>
        </Carousel>
        {/* Flechas */}
        <button
          onClick={goToPrev}
          style={{
            position: "absolute",
            top: "50%",
            left: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <LeftOutlined style={{ fontSize: "18px" }} />
        </button>
        <button
          onClick={goToNext}
          style={{
            position: "absolute",
            top: "50%",
            right: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <RightOutlined style={{ fontSize: "18px" }} />
        </button>
      </div>
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center cards-container2">
          <div className="col-md-4 cards-container2">
            <a href="ppestimulos" className="card3-link">
              <div className="card3">
                <img
                  src={fomento}
                  alt="Fomento y Estímulos"
                  className="image3"
                />
                <div className="label3">
                  <span>Fomento <br /> y Estímulos</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-4 cards-container2">
            <a href="ppformacion" className="card3-link">
              <div className="card3">
                <img
                  src={formacion}
                  alt="Formación Artística"
                  className="image3"
                />
                <div className="label3">
                  <span>Formación <br /> Artística</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-4 cards-container2">
            <a href="ppfortalecimiento" className="card3-link">
              <div className="card3">
                <img
                  src={fortalecimiento}
                  alt="Fortalecimiento al Sector Cultural"
                  className="image3"
                />
                <div className="label3">
                  <span>Fortalecimiento <br /> al Sector Cultural</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-4 cards-container2">
            <a href="ppagenda" className="card3-link">
              <div className="card3">
                <img
                  src={agenda}
                  alt="Agenda Cultural"
                  className="image3"
                />
                <div className="label3">
                  <span>Agenda <br /> Cultural</span>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-4 cards-container2">
            <a href="ppcic" className="card3-link">
              <div className="card3">
                <img
                  src={cic}
                  alt="Centro de Investigación Cultural"
                  className="image3"
                />
                <div className="label3">
                  <span>Centro de <br /> Investigación <br /> Cultural (CIC)</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <strong>
            <h1 style={{color: '#1e3a53'}}>
              GALERÍA
            </h1>
          </strong>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            Revive los momentos más especiales de nuestras actividades, encuentros y jornadas de participación.
          </h4>
        </div>
      </div>
      <div className="gallery-container">
        <div className="gallery-grid">
          {imageUrls.map((link, i) =>
            failedImages.has(i) ? (
              <div key={i} className="iframe-wrapper">
                <iframe
                  src={link}
                  title={`iframe-${i}`}
                  width="100%"
                  height="200"
                  className="gallery-iframe"
                />
                <div className="iframe-overlay" onClick={() => openModal(i)} />
              </div>
            ) : (
              <img
                key={i}
                src={link}
                alt={`imagen-${i}`}
                onError={() => handleImageError(i)}
                onClick={() => openModal(i)}
              />
            )
          )}
        </div>
        {selectedIndex !== null && (
          <div className="gallery-modal" onClick={closeModal}>
            <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
              <button onClick={prev}>&larr;</button>
                {failedImages.has(selectedIndex) ? (
                  <iframe
                    src={imageUrls[selectedIndex]}
                    width="100%"
                    height="100%"
                    title={`iframe-modal-${selectedIndex}`}
                  />
                ) : (
                  <img src={imageUrls[selectedIndex]} alt="modal-img" />
                )}
              <button onClick={next}>&rarr;</button>
              <span className="close-button" onClick={closeModal}>×</span>
            </div>
          </div>
        )}
      </div>
      <br />
      <section className="video-section">
        <div className="video-wrapper">
          <div className="video-frame">
            <iframe
              src="https://drive.google.com/file/d/1JSVSP611c4swqrW3rr5kgXi4u8VUawel/preview"
              allow="autoplay"
              allowFullScreen
              loading="lazy"
              title="Video"
            ></iframe>
          </div>
          <div className="video-text">
            <h2>¿Por qué ser parte de la Convocatoria de Estímulos 2025?</h2>
            <p>
            Este video te muestra cómo tu creatividad puede transformar la ciudad. Escucha las voces que ya han hecho parte de esta experiencia y descubre por qué tu proyecto también puede marcar la diferencia.
            </p>
            <div className="social-icons">
              <a href="#"><AiFillFacebook /></a>
              <a href="#"><AiFillInstagram /></a>
              <a href="#"><AiFillYoutube  /></a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
